import { useQuery } from "react-query";
import { fetchPatient, fetchPatientCommands, fetchPatients, fetchPatientStats } from "../queries/patient.queries";
import { PaginatedFilter } from "../types/axios.types";

export const usePatient = (id: number | string | undefined) => {
  return useQuery(["patient", id], () => {
    try {
      return fetchPatient(id);
    } catch (err) {
      return null;
    }
  });
};

export const usePatientsPaginated = () => {
  return (
    page?: number,
    size?: number,
    search?: string,
    filters?: PaginatedFilter,
    sortBy?: string[]
  ) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const query = useQuery(
      ["center-patients-paginated", page, size, search, filters, sortBy],
      () => {
        try {
          return fetchPatients(page, size, search, filters, sortBy);
        } catch (err) {
          return null;
        }
      },
      { keepPreviousData: true }
    );
    return query?.data;
  };
};

export const usePatientStats = (id: number | string | undefined) => {
  return useQuery(["patient", "stats", id], () => {
    try {
      return fetchPatientStats(id);
    } catch (err) {
      return null;
    }
  });
};

export const usePatientCommands = (id: number | string | undefined) => {
  return (page?: number, size?: number, search?: string, filters?: PaginatedFilter, sortBy?: string[]) => {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      const query = useQuery(['patient-commands', id, page, size, search, filters, sortBy], () => {
          try {
              return fetchPatientCommands(id, page, size, search, filters, sortBy);
          } catch (err) {
              return null;
          }
      }, { keepPreviousData: true })
      return query.data
  }
}